"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationsList = exports.ButtonContainer = exports.SectionHeader = exports.SegmentedButtonGroup = exports.Toolbar = exports.FilterLabel = exports.Accordion = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const accordions_1 = require("@kyruus/accordions");
const button_1 = require("@kyruus/button");
const ui_theme_1 = require("@kyruus/ui-theme");
const ProviderLocations_1 = __importDefault(require("../../ProviderLocations"));
exports.Accordion = (0, styled_1.default)(accordions_1.Accordion) `
  width: 100%;
  & .MuiAccordionSummary-root > .MuiAccordionSummary-content,
  & .MuiAccordionSummary-root.Mui-expanded > .MuiAccordionSummary-content {
    align-items: center;
    column-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
  & .MuiAccordionDetails-root > * {
    :focus-within {
      box-shadow: none;
      background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    }
  }
  & .MuiAccordionDetails-root > div:first-of-type {
    margin-top: -1px;
  }
`;
exports.FilterLabel = (0, styled_1.default)('label') `
  flex: 1 1 33%;
`;
exports.Toolbar = (0, styled_1.default)('div') `
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  > *:nth-child(2n) {
    justify-self: flex-end;
    flex-flow: row wrap;
    justify-content: flex-end;
  }
  > * {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.SegmentedButtonGroup = (0, styled_1.default)(button_1.SegmentedButton.Group) `
  flex-flow: row wrap;
  justify-content: flex-end;
`;
exports.SectionHeader = (0, styled_1.default)('h5') `
  padding: 0;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')} 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
`;
exports.ButtonContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-end;
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  width: 100%;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
`;
exports.LocationsList = (0, styled_1.default)(ProviderLocations_1.default) `
  & ul {
    overflow-y: auto;
    max-height: none;
  }
`;
//# sourceMappingURL=CollapsibleFilters.styles.js.map